import { Box, Container, Stack, Typography, useMediaQuery } from "@mui/material";
import founderConstants from "../../data/about/founder.json";
import { baseurl } from "../../config";
import galleryImages from "../../data/gallery/2025.json";
import { GalleryCardComponent, GalleryImages } from "../../components/GalleryCard";

type Props = {};

const Gallery = (props: Props) => {
    const isSmallScreen = useMediaQuery("(max-width:650px)");
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: 'repeat(1, 1fr)',  // Mobile: 1 column
                    sm: 'repeat(2, 1fr)',  // Tablet: 2 columns
                    md: 'repeat(3, 1fr)',  // Desktop: 2 columns
                    lg: 'repeat(3, 1fr)'
                },
                flexWrap: "wrap",
                justifyItems: "center",
                gap: 6,
                width: "100%"
            }}
        >
            {(galleryImages).map(image => <GalleryCardComponent display="flex" key={image.id} height={image.height ? image.height : undefined} width={image.width ? image.width : undefined} id={image.id} path={image.image} alt="gallery image" />)}
        </Box>
    );
};

export default Gallery;
